interface Step {
  number: number;
  title: string;
  description: string;
}

const steps: Step[] = [
  {
    number: 1,
    title: 'Escolha o tipo de diagnóstico',
    description: 'Selecione entre Governança de Produtos ou Performance da Operação Tech.',
  },
  {
    number: 2,
    title: 'Responda às perguntas',
    description: 'Experiência guiada e objetiva, focada no que realmente impacta resultado.',
  },
  {
    number: 3,
    title: 'Receba seu diagnóstico',
    description: 'Scores personalizados, análise de gargalos e recomendações acionáveis.',
  },
];

export function HowItWorks() {
  return (
    <section
      className="py-24 px-4 sm:px-8 lg:px-16 bg-secondary/30"
      aria-labelledby="how-it-works-heading"
    >
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16 space-y-4">
          <span className="text-primary text-sm font-medium uppercase tracking-widest">
            Processo
          </span>
          <h2 id="how-it-works-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold">
            Como funciona
          </h2>
          <p className="text-muted-foreground text-lg">
            Tempo total estimado:{' '}
            <span className="text-foreground font-semibold">5-10 minutos</span>
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection line */}
          <div className="hidden lg:block absolute top-8 left-[calc(16.67%-2rem)] right-[calc(16.67%-2rem)] h-px bg-border" />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
            {steps.map((item) => (
              <div key={item.number} className="relative text-center">
                {/* Number circle */}
                <div className="mx-auto mb-6 w-16 h-16 rounded-full bg-primary flex items-center justify-center text-2xl font-bold text-white relative z-10">
                  {item.number}
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold mb-3">{item.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
